import { providers } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { serviceProviderUiDefaults } from '../util/index.js';

export default providers.syndigo.extend({
  ...serviceProviderUiDefaults,
  hasIntrospectableSchema: Boolean(providers.syndigo.introspectionType),
  avatarPath: avatars.syndigo,
  logoPath: logos.syndigo
});
